import { connect } from 'react-redux';
import GenericLoader from '../util/GenericLoader';
import { getDataRequestsAction } from '../../redux/actions/dataRequest';

const DataRequestsLoader = connect(null, (dispatch, { variant }) => ({
  fetchFunction: () => {
    if (variant === 'super-admin') dispatch(getDataRequestsAction('all'));
    else if (variant === 'org-admin') dispatch(getDataRequestsAction('org'));
    else dispatch(getDataRequestsAction('user'));
  },
}))(GenericLoader);

export default DataRequestsLoader;
